import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchWorkoutTemplateApi = async ({ coachId }) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_WORKOUT_TEMPLATE_LIST}/${coachId}?PageNumber=1&PageSize=1000`
    );
    return await response.data;
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch workout templates"
    );
  }
};

export const fetchWorkoutTemplateByApi = async ({ Id }) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_WORKOUT_TEMPLATE_BY_ID}/${Id}`
    );
    return await response.data;
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch workout template details"
    );
  }
};
